/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaTextLink/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TysiaTextLink({
  children,
  viewPath = "/DesignSystem/TysiaTextLink",
  alignSelf,
  disabled,
  onClick,
  goTo,
  target = "_blank",
  marginTop = 0,
  marginLeft = 0,
  marginRight = 0,
  marginBottom = 0,
  flexGrow,
  flexShrink,
  flexBasis,
  size = "normal",
  color,
  fontStyle,
  text = "Default text",
  weight,
  maxWidth
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtTysiatextlinkColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaTextLink.color.primary.base'
        })
  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="TysiaTextLink.Vertical"
  data-view-path={viewPath}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onClick}
 target={target}
 style={{'--as-1-ZisbDD': alignSelf,'--mt-2-ZisbDD': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ml-3-ZisbDD': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-4-ZisbDD': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-5-ZisbDD': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--fg-6-ZisbDD': flexGrow,'--fs-7-ZisbDD': flexShrink,'--fb-8-ZisbDD': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 cursor={disabled ? "normal" : "pointer"}
 size={size}
 color={color || dtTysiatextlinkColorPrimaryBase}
 fontStyle={fontStyle}
 lineHeight="20px"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 overflowX="hidden"
 display="inline-block"
 text={text}
 textDecoration={isHovered ? "underline" : disabled ? "none" : "none"}
 weight={weight}
 maxWidth={maxWidth}
/>
</a>
{children}
</React.Fragment>)
}